import { getConsultantsList } from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, hideErrorMessage } from "./ui";

//Загрузка списка консультантов
export const CONSULTANTS_LOADING_START = "Consultants loading start";
export const CONSULTANTS_LOADING_SUCCESS = "Consultants list loading success";
export const CONSULTANTS_LOADING_FAILED = "Failure during consultants list load";

//Пагинация
export const CHANGE_CONSULTANTS_PAGE = "Change consultants page";
export const CHANGE_CONSULTANTS_LIMIT = "Change consultants limit";

//Поиск
export const CHANGE_CONSULTANTS_SEARCH = "Change consultants search";
export const START_CONSULTANTS_SEARCH = "Switch consultants search";
export const CLEAR_CONSULTANTS_SEARCH = "Clear consultants search";

//Сортировка
export const CHANGE_CONSULTANTS_SORTING = "Change consultants sorting options";

const startLoading = () => ({
  type: CONSULTANTS_LOADING_START
});

const loadSuccess = consultants => ({
  type: CONSULTANTS_LOADING_SUCCESS,
  payload: {
    consultants: consultants || []
  }
});

const loadFailure = () => ({
  type: CONSULTANTS_LOADING_FAILED,
});

//Загрузка списка консультантов
export const getConsultantsListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let consultants;
    try {
      const accessToken = localStorage.getItem("accessToken");
      consultants = await getConsultantsList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка консультантов!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(consultants));
  };
};

//Пагинация на странице списка консультантов
export const changeConsultantsPage = activePage => ({
  type: CHANGE_CONSULTANTS_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка консультантов
export const changeConsultantsLimit = activeLimit => ({
  type: CHANGE_CONSULTANTS_LIMIT,
  payload: { activeLimit }
});

//Поиск
export const changeConsultantsSearch = value => ({
  type: CHANGE_CONSULTANTS_SEARCH,
  payload: { value }
});

export const startConsultantsSearch = value => ({
  type: START_CONSULTANTS_SEARCH,
  payload: { value }
});

export const clearConsultantsSearch = () => ({
  type: CLEAR_CONSULTANTS_SEARCH,
});

//Сортировка
export const changeConsultantsSorting = (sort, order) => ({ 
  type: CHANGE_CONSULTANTS_SORTING,
  payload: { sort, order }
});